import React, { useEffect, useState } from 'react'
import propTypes from 'prop-types'
import {
  Box,
  Drawer,
  Toolbar,
  CMSContent,
  Text,
  Icon,
  Button,
  Dropdown,
  ClickableContent,
} from '@deseretbook/react-ui'
import useDropdown from '../../../hooks/useDropdown'
import SharePallette from './SharePallette'
import formatAuthorNames from '../../../utils/formatAuthorNames'
import { detailsUrl } from '../../../utils/routes'
import CopyTooltip from '../../tooltips/CopyTooltip'
import { updateContinueMedia } from '../../../utils/updateContinueMedia'

/* eslint import/prefer-default-export: 0 */

/**
 * Popup audiobook player.
 * @returns {function} Component
 */
const PopupPlayer = ({ currentChapter, chapters, children, mediaInfo }) => {
  const [mediaInfoVisible, setMediaInfoVisible] = useState(false)
  const [shareModalVisible, setShareModalVisible] = useState(false)

  const dropdown = useDropdown()

  // // Grabs and removes the extra close button from the drawer
  // const drawerCloseButton = document.querySelector('button[aria-label="Close Drawer"]')

  // if (drawerCloseButton) {
  //   drawerCloseButton.style.display = 'none'
  // }

  const authors = formatAuthorNames(mediaInfo.authors)
  const chapterNumber = chapters.findIndex((chapter) => chapter.name === currentChapter.name) + 1
  const sku = mediaInfo && mediaInfo.audiobook && mediaInfo.audiobook.sku
  const landingPage = detailsUrl(mediaInfo.mediaId, sku)

  const dbcomUrl = (mediaInfo && mediaInfo.audiobook && mediaInfo.audiobook.productUrl) || ''

  useEffect(() => {
    updateContinueMedia(mediaInfo, 'audiobook')

    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Box isColumn height="97vh" alignItems="center" marginTop={1.5}>
        <Box
          alignItems="center"
          justifyContent="center"
          isColumn
          maxWidth="356px"
          style={{ position: 'relative' }}
        >
          <Text
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 700,
              fontSize: '16px',
            }}
          >
            {mediaInfo.title}
          </Text>
          <Text
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 400,
              fontSize: '14px',
              color: '#000000A6',
            }}
          >
            {authors}
          </Text>
          <Box
            alignItems="center"
            marginLeft={1}
            style={{ position: 'absolute', top: 0, right: -60 }}
          >
            <Box
              alignItems="center"
              justifyContent="center"
              style={{ minWidth: '2rem' }}
              {...dropdown.triggerProps}
              tabIndex={0}
            >
              <ClickableContent isPaddingless>
                <Icon name="options" />
              </ClickableContent>
            </Box>
          </Box>
        </Box>
        <Box
          justifyContent="center"
          alignItems="center"
          isColumn
          style={{ position: 'relative' }}
          maxWidth="356px"
        >
          <img
            src={mediaInfo.cover && mediaInfo.cover.fullUrl}
            alt={mediaInfo.title}
            style={{
              width: '300px',
              minHeight: '300px',
              alignSelf: 'center',
              borderRadius: '20px',
              boxShadow: '0 12px 12px #0000001F',
              margin: '24px',
            }}
          />{' '}
          <Text
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 700,
              fontSize: '16px',
              marginBottom: '24px',
              textAlign: 'center',
            }}
          >
            Chapter {chapterNumber} - {currentChapter.name}
          </Text>
          <Drawer isOpen={mediaInfoVisible} onClose={() => setMediaInfoVisible(!mediaInfoVisible)}>
            <Toolbar
              titleContent="Audiobook Info"
              leftActionIcon="close"
              onLeftAction={() => setMediaInfoVisible(!mediaInfoVisible)}
            />
            <Drawer.Content>
              <Box padding={0.5}>
                <CMSContent
                  dangerouslySetInnerHTML={{ __html: mediaInfo.description }}
                  itsNotDangerousBecause="mediaInfo.description comes directly from the Bookshelf API, and should be trustworthy"
                />
              </Box>
            </Drawer.Content>
          </Drawer>
        </Box>
        {children}
        <SharePallette
          isOpen={shareModalVisible}
          content={mediaInfo}
          onClick={() => setShareModalVisible(!shareModalVisible)}
          onClose={() => setShareModalVisible(!shareModalVisible)}
        />
      </Box>
      <Dropdown {...dropdown.dropdownProps} id="MediaCardDropdown">
        <Box isColumn alignItems="start" className="MediaCardLinkContainer">
          <a target="_blank" rel="noreferrer" href={landingPage} className="MediaCardLink">
            <Icon name="info" className="link-icon" />
            <Text>Title Details</Text>
          </a>
          <CopyTooltip textToCopy={dbcomUrl}>
            <Button
              onClick={() => {
                navigator.clipboard.writeText(dbcomUrl)
              }}
              className="MediaCardLink"
              style={{ border: 'none' }}
            >
              <Icon name="share" className="link-icon" />
              <Text>Share Title</Text>
            </Button>
          </CopyTooltip>
        </Box>
      </Dropdown>
    </>
  )
}

PopupPlayer.propTypes = {
  children: propTypes.node.isRequired,
  mediaInfo: propTypes.shape({}),
  chapters: propTypes.arrayOf(propTypes.object),
  currentChapter: propTypes.shape({}),
  onSelectChapter: propTypes.func,
}

PopupPlayer.defaultProps = {
  mediaInfo: {},
  chapters: [],
  currentChapter: {},
  onSelectChapter: () => {},
}

export default PopupPlayer
